<template>
  <div>
    <h1>Mailing</h1>
    <h2>Servicio manual para envío de emails</h2>
    <form class="col-lg-10 col-12 form_mailing">
      <div class="form-group">
        <label style="width:100%; color:#595959; text-align:start;" for="exampleFormControlInput1">Asunto del email</label>
        <input 
          type="text" 
          class="form-control" 
          id="exampleFormControlInput1" 
          placeholder="Asunto" 
          autocomplete="off"
          v-model="form.subject"
        >
        <span
          v-if="errors.subject"
          class="text-danger float-left small error-danger mb-2"
        >{{ errors.subject }}</span><br>
      </div>

      <!-- Botones para escoger el tipo de contenido del email -->
      <div class="btns_content">
        <span>Escoge el formato de contenido</span>
        <button
          @click="form.btnContent = 1"
          type="button"
          class="btn btn-success"
          style="background-color:white; color:#595959;"
          :class="{ 'btn_selected': form.btnContent == 1 }"
        >
          Texto
        </button>
        <button
          @click="form.btnContent = 2"
          type="button"
          class="btn btn-success"
          style="background-color:white; color:#595959;"
          :class="{ 'btn_selected': form.btnContent == 2 }"
        >
          HTML
        </button>
        <button
          @click="form.btnContent = 3"
          type="button"
          class="btn btn-success"
          style="background-color:white; color:#595959;"
          :class="{ 'btn_selected': form.btnContent == 3 }"
        >
          Personalizado
        </button>
      </div>
      <!-- Fin botones para escoger el tipo de contenido del email -->

      <!-- Sección contenido del email -->
      <div v-if="form.btnContent == 1" class="form-group">
        <label style="width:100%; color:#595959; text-align:start;" for="exampleFormControlTextarea1">Contenido del email</label>
        <textarea 
          class="form-control" 
          id="exampleFormControlTextarea1" 
          rows="5"
          v-model="form.emailContent"
        ></textarea>
        <br>
        <span
          v-if="errors.emailContent"
          class="text-danger float-left small error-danger mb-2"
        >{{ errors.emailContent }}</span><br>
      </div>

      <div v-else-if="form.btnContent == 2" class="form-group">
        <label style="width:100%; color:#595959; text-align:start;" for="exampleFormControlTextarea2">Pega aquí el HTML</label>
        <textarea 
          v-model="form.htmlContent" 
          class="form-control" 
          id="exampleFormControlTextarea2" 
          rows="5"
        ></textarea>
        <br>
        <span
          v-if="errors.htmlContent"
          class="text-danger float-left small error-danger mb-2"
        >{{ errors.htmlContent }}</span><br>
        <div :class="{ content_html_show: form.htmlContent != null }" class="content_html" v-html="form.htmlContent"></div>
      </div>

      <div v-else-if="form.btnContent == 3" class="form-group">
        <label style="width:100%; color:#595959; text-align:start;" for="exampleFormControlTextarea3">Contenido personalizado del email</label>
        <textarea 
          class="form-control" 
          id="exampleFormControlTextarea3" 
          rows="5"
          v-model="form.emailContentPersonalized"
        ></textarea>
        <br>
        <span
          v-if="errors.emailContentPersonalized"
          class="text-danger float-left small error-danger mb-2"
        >{{ errors.emailContentPersonalized }}</span><br>
      </div>
      <!-- Fin sección contenido del email -->

      <!-- Botones para escoger destinatarios -->
      <div class="btns_content">
        <span>Escoge el tipo de destinatarios</span>
        <button
          @click="form.btnRecipients = 1"
          type="button"
          class="btn btn-success"
          style="background-color:white; color:#595959;"
          :class="{ 'btn_selected': form.btnRecipients == 1 }"
        >
          Por distribuidor
        </button>
        <button
          @click="form.btnRecipients = 2"
          type="button"
          class="btn btn-success"
          style="background-color:white; color:#595959;"
          :class="{ 'btn_selected': form.btnRecipients == 2 }"
        >
          Por tipo de usuario
        </button>
        <button
          @click="form.btnRecipients = 3"
          type="button"
          class="btn btn-success"
          style="background-color:white; color:#595959;"
          :class="{ 'btn_selected': form.btnRecipients == 3 }"
        >
          Archivo Excel
        </button>
      </div>
      <!-- Fin botones para escoger destinatarios -->

      <!-- Sección para escoger el tipo de destinatarios -->
      <div v-if="form.btnRecipients == 1" class="add_distributors">
        <label style="width:100%; color:#595959; text-align:start;">Seleccionar distribuidor</label>
        <div class="input-group mb-3 mt-2">
          <div class="input-group-prepend">
            <label class="input-group-text" for="inputGroupSelect01">Distribuidores</label>
          </div>
          <select 
            class="custom-select" 
            id="inputGroupSelect01"
            v-model="form.typeDistributor"
            @change="selectedDistributor()"
          >
            <option value="null" selected disabled>Seleccione</option>
            <option v-for="item in allDistributors" :key="item.id" :value="item">{{ item.name }}</option>
          </select>
        </div>
        <span
          v-if="errors.typeDistributor"
          class="text-danger float-left small error-danger mb-2"
        >{{ errors.typeDistributor }}</span><br>
      </div>

      <div v-if="form.btnRecipients == 1 && form.typeDistributor != null" class="add_users_by_dist">
        <label style="width:100%; color:#595959; text-align:start;">Seleccionar destinatarios</label>
        <div class="input-group mb-3 mt-2">
          <div class="input-group-prepend">
            <label class="input-group-text" for="inputGroupSelect02">Destinatarios</label>
          </div>
          <select 
            class="custom-select" 
            id="inputGroupSelect02"
            v-model="form.typeUserByDist"
            @change="selectedUsersByDist()"
          >
            <option value="null" selected disabled>Seleccione</option>
            <option value="1">Moteros</option>
            <option value="2">Lubricadores</option>
            <option value="3">Moteros y Lubricadores</option>
          </select>
        </div>
        <span
          v-if="errors.typeUserByDist"
          class="text-danger float-left small error-danger mb-2"
        >{{ errors.typeUserByDist }}</span><br>
        <div v-if="form.btnRecipients == 1 && form.typeDistributor != null && form.typeUserByDist != null" style="display:grid; color:#595959;">
          <span style="margin:auto;">El email se enviará a los usuarios con rol: 
            <strong>
              {{ form.typeUserByDist == 1 ? 'Motero' : form.typeUserByDist == 2 ? 'Lubricador' : 'Motero y Lubricador' }} 
            </strong>
            con distribuidor: <strong>{{ form.typeDistributor.name }}</strong>
          </span>
        </div>
      </div>


      <div v-if="form.btnRecipients == 2" class="add_users">
        <label style="width:100%; color:#595959; text-align:start;">Seleccionar destinatarios</label>
        <div class="input-group mb-3 mt-2">
          <div class="input-group-prepend">
            <label class="input-group-text" for="inputGroupSelect03">Destinatarios</label>
          </div>
          <select 
            class="custom-select" 
            id="inputGroupSelect03"
            v-model="form.typeUser"
            @change="selectedUsers()"
          >
            <option value="null" selected disabled>Seleccione</option>
            <option value="1">Moteros</option>
            <option value="2">Lubricadores</option>
            <option value="3">Moteros y Lubricadores</option>
          </select>
        </div>
        <span
          v-if="errors.typeUser"
          class="text-danger float-left small error-danger mb-2"
        >{{ errors.typeUser }}</span><br>
        <div style="display:grid; color:#595959;" v-if="form.btnRecipients == 2 && form.typeUser != null">
          <span style="margin:auto;">El email se enviará a los usuarios con rol de: <strong>{{ form.typeUser == 1 ? 'Motero' : form.typeUser == 2 ? 'Lubricador' : 'Ambos roles' }}</strong></span>
        </div>
      </div>
    
      <div v-if="form.btnRecipients == 3" class="add_users_file">
        <label style="width:100%; color:#595959; text-align:start;">Añadir destinatarios mediante archivo excel</label>
        <div class="input-group mb-3 mt-2">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroupFileAddon01">Subir archivo</span>
          </div>
          <div class="custom-file">
            <input 
              type="file"
              accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-exce"
              class="custom-file-input" 
              id="inputGroupFile01" 
              aria-describedby="inputGroupFileAddon01"
              @change="handleFileUpload()"
              ref="fileUsers"
            >
            <label class="custom-file-label" for="inputGroupFile01">Escoger archivo</label>
          </div>
        </div>
        <span
          v-if="errors.usersSelectedByExcel"
          class="text-danger float-left small error-danger mb-2"
        >{{ errors.usersSelectedByExcel }}</span><br>
        
        <div style="display:grid; color:#595959;" v-if="form.usersSelectedByExcel.length > 0">
          <span style="margin:auto;"><strong>{{ fileName }}</strong></span>
          <span style="margin:auto;">Cantidad de destinatarios: <strong>{{ form.usersSelectedByExcel.length }}</strong></span>
        </div>
      </div>
      <!-- Fin sección para escoger el tipo de destinatarios -->

      <div class="sendEmails">
        <button 
          type="button" 
          class="btn btn-danger"
          @click="sendEmail()"
        >
          <div v-if="sending" style="display:flex;">
            <template>
              Enviando...&nbsp;
            </template>
            <div class="loader"></div>
          </div>
          
          <div v-else>
            <template>
              Enviar email
            </template>
          </div>
        </button>
      </div>

      <!-- Barra de progreso de envío -->
      <!-- <div style="padding:25px 0px;">
        <div style="padding:5px 0px;">
          <span style="color:#595959">Progreso del envío: <b>{{ progress }}%</b></span>
        </div>
        <progress-bar 
          :val="progress" 
          max="100" 
          size="15" 
          bg-color="#e9ecef" 
          bar-color="#28a745"
        >
          {{ progress }}
        </progress-bar>
      </div> -->

      <div class="aviso">
        <span>
          El envío puede tardar unos minutos en completarse, 
          dependiendo la cantidad de destinatarios.
        </span>
      </div>

    </form>
  </div>
</template>

<script>
import axios from 'axios';
import readXlsFile from 'read-excel-file';
// import ProgressBar from 'vue-simple-progress';

export default {
  name: "sendEmails",

  components: {
    // ProgressBar
  },

  data(){
    return{
      fileName: null,
      allUsers: [],
      usersBoth: [],
      usersLub: [],
      usersMot: [],
      
      allDistributors: [],
      usersByDist:[],

      // form
      form: {
        subject: null,
        emailContent: null,
        htmlContent: null,
        emailContentPersonalized: null,
        typeUser: null,
        typeUserByDist: null,
        usersSelected: [],
        typeDistributor: null,
        usersSelectedByDist: [],
        usersSelectedByExcel: [],
        btnContent: 1,
        btnRecipients: 1,
      },

      errors: {
        subject: false,
        emailContent: false,
        htmlContent: false,
        emailContentPersonalized: false,
        typeDistributor: false,
        typeUser: false,
        typeUserByDist: false,
        usersSelectedByExcel: false,
      },
      sending: false,
      progress: 0,
    };
  },
  methods:{
    getAllUsers(){
      var app = this;
      axios
      .get('superAdmin/get/users')
      .then((response) => {
        if(response.data.cod == 0){
          app.allUsers = response.data.data;
          app.usersLub = app.allUsers.filter(
            user => user.role_id === 4 && (user.email != "" && user.email != null)
          );
          app.usersMot = app.allUsers.filter(
            user => user.role_id === 5 && (user.email != "" && user.email != null)
          );
          app.usersBoth = app.allUsers.filter(
            user => (user.role_id === 4 || user.role_id === 5) && (user.email != "" && user.email != null)
          );
        } else {
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },
    getDistributors(){
      var app = this;
      axios
      .get('superAdmin/get/distributors')
      .then((response) => {
        if(response.data.cod == 0){
          app.allDistributors = response.data.data;
        } else {
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },
    selectedDistributor(){
      var app = this;
      axios
      .post('superAdmin/get/users/by/distributor/' + this.form.typeDistributor.id)
      .then((response) => {
        if(response.data.cod == 0){
          app.form.usersByDist = response.data.data.filter(
            user => user.email != "" && user.email != null
          );
        } else {
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },
    selectedUsersByDist(){
      if(this.form.typeUserByDist == 1){
        this.form.usersSelectedByDist = this.form.usersByDist.filter(
          user => user.role_id == 5
        );
      }
      else if(this.form.typeUserByDist == 2){
        this.form.usersSelectedByDist = this.form.usersByDist.filter(
          user => user.role_id == 4
        );
      } else {
        this.form.usersSelectedByDist = this.form.usersByDist;
      }
    },
    selectedUsers(){
      if(this.form.typeUser == 1){
        this.form.usersSelected = this.usersMot;
      }
      else if(this.form.typeUser == 2){
        this.form.usersSelected = this.usersLub;
      } else {
        this.form.usersSelected = this.usersBoth;
      }
    },
    handleFileUpload(){
      const file = this.$refs.fileUsers.files[0];
      readXlsFile(file).then((rows) => {
        const headers = rows[0];
        const possibleColumnNames = ['Email', 'email', 'Emails', 'emails', 'EMAIL', 'EMAILS'];
        const possibleRoleColumnNames = ['Rol', 'rol', 'Roles', 'roles', 'ROL', 'ROLES'];
        const possibleDistributorColumnNames = ['Distribuidor', 'distribuidor', 'Distribuidores', 'distribuidores', 'DISTRIBUIDOR', 'DISTRIBUIDORES'];
        let emailColumnIndex = -1;
        let roleColumnIndex = -1;
        let distributorColumnIndex = -1;

        // Encuentra la posición de la columna "Email" y "Rol" en las cabeceras.
        for (const name of possibleColumnNames) {
          emailColumnIndex = headers.indexOf(name);
          if (emailColumnIndex !== -1) {
            break;
          }
        }
        for (const name of possibleRoleColumnNames) {
          roleColumnIndex = headers.indexOf(name);
          if (roleColumnIndex !== -1) {
            break;
          }
        }
        for (const name of possibleDistributorColumnNames) {
          distributorColumnIndex = headers.indexOf(name);
          if (distributorColumnIndex !== -1) {
            break;
          }
        }

        if (emailColumnIndex !== -1 && roleColumnIndex !== -1 && distributorColumnIndex !== -1) {
          // Extrae los correos electrónicos y roles de las respectivas columnas.
          this.form.usersSelectedByExcel = rows.slice(1).map((row) => {
            const email = row[emailColumnIndex] === undefined ? 'email' : row[emailColumnIndex];
            const rol = row[roleColumnIndex] === undefined ? 'rol' : row[roleColumnIndex];
            const distribuidor = row[distributorColumnIndex] === undefined ? 'distribuidor' : row[distributorColumnIndex];
            return { email, rol, distribuidor };
          });
          this.fileName = this.$refs.fileUsers.files[0].name;
        } else {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "warning",
            title: "Oops...",
            text: "No se encontró alguna de las columnas 'email', 'rol' o 'distribuidor' en el archivo Excel. Puedes consultar la sección 'Como enviar emails' en el inicio del CRM para más información.",
          });
        }
      });
    },
    validForm(){
      var app = this;
      if(!app.form.subject){
        app.errors.subject = "El asunto es obligatorio.";
        return false;
      } else {
        app.errors.subject = false;
      }
      if(app.form.btnContent == 1){
        if(!app.form.emailContent){
          app.errors.emailContent = "El contenido del email es obligatorio.";
          return false;
        } else {
          app.errors.emailContent = false;
        }
      }
      if(app.form.btnContent == 2){
        if(!app.form.htmlContent){
          app.errors.htmlContent = "El contenido en HTML del email es obligatorio.";
          return false;
        } else {
          app.errors.htmlContent = false;
        }
      }
      if(app.form.btnContent == 3){
        if(!app.form.emailContentPersonalized){
          app.errors.emailContentPersonalized = "El contenido personalizado del email es obligatorio.";
          return false;
        } else {
          app.errors.emailContentPersonalized = false;
        }
      }
      if(app.form.btnRecipients == 1){
        if(!app.form.typeDistributor){
          app.errors.typeDistributor = "El tipo de distribuidor es obligatorio.";
          return false;
        }
      }
      if(app.form.btnRecipients == 2){
        if(!app.form.typeUser){
          app.errors.typeUser = "El tipo de usuario es obligatorio.";
          return false;
        }
      }
      if(app.form.btnRecipients == 3){
        if(app.form.usersSelectedByExcel.length == 0){
          app.errors.usersSelectedByExcel = "El archivo Excel es obligatorio.";
          return false;
        }
      }

      return true;
    },
    sendEmail(){
      var app = this;
      // console.log('this.form ', JSON.stringify(this.form));
      if(app.validForm()){
        app.sending = true;
        axios
        .post('superAdmin/send/email', this.form, {
          onDownloadProgress: function(progressEvent) {
            console.log('download', progressEvent);
          }
        })
        .then((response) => {
          if(response.data.cod == 0){
            app.$swal({
              icon: "success",
              title: "¡Excelente!",
              text: response.data.message,
              confirmButtonColor: "#28a745",
            });
            app.sending = false;
          } else {
            app.$swal({
              icon: "error",
              title: "Oops...",
              text: response.data.message,
              confirmButtonColor: "#dc3545",
            });
            app.sending = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      }
    },
  },
  watch:{
    "form.subject": function(value) {
      if (!value) {
        this.errors.subject = "El asunto es obligatorio.";
      } else {
        this.errors.subject = false;
      }
    },
    "form.emailContent": function(value) {
      if (!value) {
        this.errors.emailContent = "El contenido del email es obligatorio.";
      } else {
        this.errors.emailContent = false;
      }
    },
    "form.htmlContent": function(value) {
      if (!value) {
        this.errors.htmlContent = "El contenido en HTML del email es obligatorio.";
      } else {
        this.errors.htmlContent = false;
      }
    },
    "form.emailContentPersonalized": function(value) {
      if (!value) {
        this.errors.emailContentPersonalized = "El contenido personalizado del email es obligatorio.";
      } else {
        this.errors.emailContentPersonalized = false;
      }
    },
    "form.typeDistributor": function(value) {
      if (!value) {
        this.errors.typeDistributor = "El tipo de distribuidor es obligatorio.";
      } else {
        this.errors.typeDistributor = false;
      }
    },
    "form.typeUser": function(value) {
      if (!value) {
        this.errors.typeUser = "El tipo de usuario es obligatorio.";
      } else {
        this.errors.typeUser = false;
      }
    },
    "form.usersSelectedByExcel": function(value) {
      if (!value) {
        this.errors.usersSelectedByExcel = "El archivo Excel es obligatorio.";
      } else {
        this.errors.usersSelectedByExcel = false;
      }
    },
  },
  mounted(){
    this.getAllUsers();
    this.getDistributors();
  }
};
</script>

<style scoped>
h1, h2{
  color: black;
  font-family: "GothamBoldItalic", sans-serif;
}
.form_mailing{
  margin: auto;
}
#exampleFormControlTextarea1{
  resize: none;
}
.btns_content{
  display: block;
}
.btns_content > button{
  margin: 15px 5px;
}
.btns_content > span{
  color: #595959;
  padding: 5px;
}
.content_html{
  padding: 15px 5px;
  display: none;
}
.content_html_show{
  padding: 15px 5px;
  display: block;
}
.custom-file-input, .custom-select{
  cursor: pointer !important;
}
.add_distributors, .add_users_by_dist, .add_users, .add_users_file{
  padding: 15px 5px;
}
.sendEmails{
  width: 100%;
  margin: 20px 0px;
  text-align: start;
}
.aviso{
  text-align: start;
  font-size: 15px;
  color:#1da5df;
}
.btn_selected{
  background-color: #28a745 !important;
  color: white !important;
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 25px;
  --b: 5px; 
  /* aspect-ratio: 1; */
  border-radius: 50%;
  padding: 1px;
  background: conic-gradient(#0000 10%,#fff) content-box;
  -webkit-mask:
    repeating-conic-gradient(#0000 0deg,#000 1deg 20deg,#0000 21deg 36deg),
    radial-gradient(farthest-side,#0000 calc(100% - var(--b) - 1px),#000 calc(100% - var(--b)));
  -webkit-mask-composite: destination-in;
          mask-composite: intersect;
  animation:l4 1s infinite steps(10);
}
@keyframes l4 {to{transform: rotate(1turn)}}


/* Fuentes */
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../../../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../../../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../../../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
</style>